import { render, staticRenderFns } from "./AuditAirTicket.vue?vue&type=template&id=468045a2&scoped=true"
import script from "../../assets/ts/tripinfo/AuditAirTicket.ts?vue&type=script&lang=ts&external"
export * from "../../assets/ts/tripinfo/AuditAirTicket.ts?vue&type=script&lang=ts&external"
import style0 from "./AuditAirTicket.vue?vue&type=style&index=0&id=468045a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468045a2",
  null
  
)

export default component.exports